export function asRoundedPercentage(val) {
    return `${Math.round(val * 100)}%`;
}